import { render, staticRenderFns } from "./TableTextItem.vue?vue&type=template&id=a3aac224&scoped=true"
import script from "./TableTextItem.vue?vue&type=script&lang=js"
export * from "./TableTextItem.vue?vue&type=script&lang=js"
import style0 from "./TableTextItem.vue?vue&type=style&index=0&id=a3aac224&scoped=true&lang=css"
import style1 from "./TableTextItem.vue?vue&type=style&index=1&id=a3aac224&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3aac224",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3aac224')) {
      api.createRecord('a3aac224', component.options)
    } else {
      api.reload('a3aac224', component.options)
    }
    module.hot.accept("./TableTextItem.vue?vue&type=template&id=a3aac224&scoped=true", function () {
      api.rerender('a3aac224', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TkCommonPage/components/tableComp/tableItems/TableTextItem.vue"
export default component.exports